import { DetailedHTMLProps, FC, SVGProps } from "react";
export const CloseIcon: FC<DetailedHTMLProps<SVGProps<SVGSVGElement>, SVGSVGElement>
> = ({className, onClick}) => (
<svg className={className} width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.83192 1.34435L13.1456 12.6581M13.1456 1.34435L7.48877 7.00121L1.83192 12.6581" stroke="black" stroke-width="2" stroke-linecap="round"/>
</svg>
);